// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__31CUz","type":"styles_type__10Vyp","choices":"styles_choices__1zU9H"};